import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { globalStateSelector } from 'store/selector';
import { messageAction, globalAction, callAction } from 'store/action';
import { HeaderDialpad } from 'modules/theme';
import moment from 'moment';
import { MenuItem } from 'react-bootstrap';
import CommonManager from '../../../helpers/common';
const commonManager = new CommonManager();

export class Header extends Component {
  constructor(props) {
    super(props);
    this.renderOtherMenu = this.renderOtherMenu.bind(this);
    this.renderState = this.renderState.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.setCallTimer = this.setCallTimer.bind(this);
    this.headerTitle = this.headerTitle.bind(this);
    this.stopCallTimer = this.stopCallTimer.bind(this);
    this.transferCancel = this.transferCancel.bind(this);
    this.allowMedia = this.allowMedia.bind(this);
    this.getMediaPermission = this.getMediaPermission.bind(this);
    this.buttonLoadingTimer = this.buttonLoadingTimer.bind(this);
    this.userOnline = this.userOnline.bind(this);
    this.timeout = "";
    this.buttonTimeout = "";
    this.callTimer = "";
    this.timer = 0;
    this.isStarted = false;
    this.state = {
      "callTimer": 0,
      "loading": false,
      "timerText": ""
    }
  }
  transferCancel() {
    const { callInfo, callProcess } = this.props
    callProcess('callTransferCancel', {
      sessionId: callInfo.sessionId,
      callId1: callInfo.agentId,
      callId2: callInfo.custId,
    });
    this.sendMessage({
      type: 'livemonitor',
      subType: 'unsubscribe'
    });
  }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  renderOtherMenu(state, Lable) {
    const { changeTab, callState } = this.props
    // dispatch(globalAction.callState({ data: false }));
    return (
      <MenuItem>
        <a onClick={() => {
          if (state == "call") {
            callState(true)
            changeTab("online")
          } else {
            changeTab(state)
          }
        }}>{Lable}</a>
      </MenuItem>
    )
  }

  async allowMedia() {
    const { dynamicUpdate, registerUser, sipConfig } = this.props;
    try {
      navigator.mediaDevices.getUserMedia({ audio: true, video: false })
        .then((stream) => {
          // microphone available
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
          dynamicUpdate({ key: 'microPhoneState', value: "registered" });
          this.buttonLoadingTimer();
          registerUser("sip", { sipConfig, forceOnline: true })
        }, e => {
          dynamicUpdate({ key: 'microPhoneState', value: "denied" });
          clearTimeout(global.__btnTimer);
        });
    } catch (error) {
      dynamicUpdate({ key: 'microPhoneState', value: "error" });
      clearTimeout(global.__btnTimer);
    }
  }
  async getMediaPermission() {
    const { dynamicUpdate, registerUser, sipConfig } = this.props;
    try {
      let microPhone = await navigator.permissions.query({ name: 'microphone' })
      if (microPhone && microPhone.state) {
        if (microPhone.state == "denied") {
          dynamicUpdate({ key: 'microPhoneState', value: "denied" });
          clearTimeout(global.__btnTimer);
        } else if (microPhone.state == "granted") {
          dynamicUpdate({ key: 'microPhoneState', value: "registered" });
          this.buttonLoadingTimer();
          registerUser("sip", { sipConfig, forceOnline: true })
        } else if (microPhone.state == "prompt") {
          dynamicUpdate({ key: 'microPhoneState', value: "prompt" });
          clearTimeout(global.__btnTimer);
          this.allowMedia();
        }
      } else {
        this.allowMedia();
      }
    } catch (ex) {
      dynamicUpdate({ key: 'microPhoneState', value: "prompt" });
      this.allowMedia();
    }
  }
  userOnline() {
    const { currentUser, dynamicUpdate } = this.props
    this.buttonLoadingTimer();
    if (currentUser.phoneType == "pstn" || currentUser.phoneType == "mobileEndPoint") {
      let message = {
        type: 'stateHandler',
        state: 'online',
        subState: '',
        stateInfo: ''
      };
      dynamicUpdate({ key: 'microPhoneState', value: "" });
      this.sendMessage(message)
    } else {
      dynamicUpdate({ key: 'microPhoneState', value: "loading" });
      try {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.getMediaPermission();
        }, 1000)
      } catch (error) {
        dynamicUpdate({ key: 'microPhoneState', value: "error" });
      }
    }
  }
  buttonLoadingTimer() {
    const { dynamicUpdate, microPhoneState } = this.props
    this.setState({ "loading": true });
    try {
      clearTimeout(global.__btnTimer);
      this.timer = 35
      dynamicUpdate({ key: 'timerText', value: "" });
      global.__btnTimer = setInterval(() => {
        this.timer--;
        if (this.timer <= 0) {
          this.setState({ "loading": false });
          dynamicUpdate({ key: 'microPhoneState', value: "" });
        } else if (this.timer < 30) {
          dynamicUpdate({ key: 'timerText', value: `Retry in ${this.timer} seconds` });
        }
      }, 1000)
    } catch (error) {
      console.log("Get Permission error", error)
    }
  }
  renderState(state, Lable) {
    const { dynamicUpdate, configProcessor, changeTab } = this.props
    return (
      <MenuItem>
        <a onClick={() => {

          if (state == "offline" || state == "online") {
            dynamicUpdate({ key: 'isPreviewDial', value: false })
            configProcessor(`previewSkip`);
            // if( state == "online" ){
            //   configProcessor(`previewCont`);
            // }
          }
          if (state == "online") {
            changeTab("offlineLoading")
            this.userOnline()
          } else {
            let message = {
              type: 'stateHandler',
              state: state,
              subState: '',
              stateInfo: ''
            };
            this.sendMessage(message);
          }
        }} style={{ cursor: 'pointer' }}>
          {Lable}
        </a>
      </MenuItem>
    )
  }
  renderMenu() {
    const { __ } = this.context;
    const { userState, onCall, selectedTab } = this.props;
    let state = userState.State || '';
    if (selectedTab == "profile") {
      return (
        // <React.Fragment>
        this.renderOtherMenu("online", "Home")
        // </React.Fragment>
      )
    } else if (selectedTab == "break") {
      return ([
        // <React.Fragment>

        this.renderOtherMenu("online", "Home"),
        !onCall && this.renderOtherMenu("logout", "Logout")

        // </React.Fragment>
      ])
    } else {
      return (
        // <React.Fragment>
        [
          (state == "break" || state == "callback") && this.renderState("online", "Online"),
          (state == "online" || state == "break") && this.renderState("offline", "Offline"),
          // (state == "online") && this.renderState("preview", "Preview"),
          (state == "offline" || state == "online") && this.renderOtherMenu("break", "Break"),
          !onCall && this.renderOtherMenu("profile", "Profile"),
          /* {this.renderState("offline", "Offline")} */
          // !onCall && this.renderOtherMenu("notification", "Notification")
        ]
        // {/* </React.Fragment> */ }
      )
    }
  }
  stopCallTimer() {
    this.isStarted = false;
    clearTimeout(this.callTimer);
    if (this.state.callTimer != 0) {
      console.log("stopCallTimer ");
      this.setState({ "callTimer": 0 })
    }
  }
  setCallTimer() {
    let _this = this;
    if (!this.isStarted) {
      this.stopCallTimer();
      this.isStarted = true;
      this.callTimer = setInterval(() => {
        _this.state.callTimer++;
        _this.setState({ "callTimer": _this.state.callTimer })
      }, 1000);
    }
  }
  timerToString(sec) {
    try {
      return moment.utc(sec * 1000).format('HH:mm:ss');
    } catch (error) {
      return "";
    }
  }
  getProfile(currentUser) {
    if (currentUser.imagePath && currentUser.profilePic) {
      return `${currentUser.imagePath}${currentUser.profilePic}`;
    } else {
      return "/images/icons/gender-neutral-user.png";
    }
  }
  headerTitle(state, onCall, mainType) {
    const { customerNumber, selectedTab, customerName, currentUser, cbTab, callTeam, callerId } = this.props;
    let AgentName = currentUser && currentUser.name ? currentUser.name : "No Name";
    let role = currentUser && currentUser.role ? currentUser.role : 0;

    let profileImage = "/images/icons/gender-neutral-user.png";
    if (!(onCall || state == "preview")) {
      profileImage = this.getProfile(currentUser);
    }
    let header = {
      "headerTitle": "",
      "background": state ? "blue" : "black",
      "isProfile": false,
      "showPreview": false,
      "showCB": false,
      "isFullProfile": false,
      "subState": "",
      "profile": profileImage,
      // DO NOT REMOVE THIS COMMENT
      // "renderInBound": false,
    }
    if (onCall) {
      header.headerTitle = customerNumber || "";
      header.Teamname = callTeam && callTeam.name ? callTeam.name : "";
      header.callerId = callerId || "";

      if (state == "CUSTOMER_CONNECTED" || state == "CONNECTED") {
        this.setCallTimer();
        header.subState = this.timerToString(this.state.callTimer);
      } else if (state == "AGENT_CONNECTING") {
        header.subState = "connecting";
        // DO NOT REMOVE THIS COMMENT
        // header.renderInBound = true;
      } else if (state == "AGENT_CONNECTED") {
        header.subState = "Ringing...";
      } else if (state == "CUSTOMER_CONNECTING") {
        header.subState = "Ringing...";
      } else if (state == "ACW") {
        header.subState = "";
        this.setCallTimer();
        header.subState = this.timerToString(this.state.callTimer);
      } else if (state == "CUSTOMER_RINING") {
        header.subState = "Ringing...";
      } else if (mainType == "call" ||
        state == "callMute" ||
        state == "callUnMute" ||
        state == "callHold" ||
        state == "callUnHold" ||
        state == "AGENT_UNMUTE" ||
        state == "AGENT_MUTE" ||
        state == "AGENT_HOLD" ||
        state == "AGENT_UNHOLD") {
        header.subState = this.timerToString(this.state.callTimer);
      } else {
        this.stopCallTimer();
      }
      header.isProfile = true;
    } else if (state == "preview" || state == "callback") {
      header.isProfile = true;
      header.headerTitle = customerName || "";
      header.subState = customerNumber || "";
      header.Teamname = callTeam && callTeam.name ? callTeam.name : "";
      header.callerId = callerId || "";
      if (state == "callback") {
        // need to show callback back button
        if (cbTab == "notify") {
          header.headerTitle = "Schedule Call";
          header.isProfile = false;
        } else if (cbTab == "list") {
          header.headerTitle = "Schedule Call List";
          header.isProfile = false;
          header.Teamname = "";
          header.callerId = "";
          header.showCB = true
        }
      } else {
        if (role == 6) {
          header.showPreview = true
        }
      }
      this.stopCallTimer();
    } else if (state == "inboundOffer") {
      header.isProfile = false;
      header.isFullProfile = true;
      header.headerTitle = customerName || "";
      header.subState = customerNumber || "";
      header.Teamname = callTeam && callTeam.name ? callTeam.name : "";
      header.callerId = callerId || "";
      this.stopCallTimer();
    } else if (state == "offline") {
      header.headerTitle = AgentName;
      header.background = "black";
      header.isProfile = true;
      this.stopCallTimer();
    } else if (state == "online") {
      header.headerTitle = "Recent"
      if (role == 6) {
        header.showPreview = true
      }
      header.showCB = true
      this.stopCallTimer();
    } else if (state == "break") {
      header.headerTitle = AgentName;
      // header.isProfile = true;
      header.background = "yellow";
      this.stopCallTimer();
    } else {

      header.headerTitle = AgentName;
      header.isProfile = true;
      this.stopCallTimer();
    }

    if (selectedTab == "break") {
      header.headerTitle = "Take a break";
      header.isProfile = false;
    } else if (selectedTab == "profile") {
      header.headerTitle = "Profile";
      header.isProfile = true;
    } else if (selectedTab == "notification") {
      header.headerTitle = "Notification";
      header.isProfile = false;
    }
    return header;
  }
  render() {
    let { userState,
      onCall,
      close,
      isConnected,
      callTab,
      changeTab,
      phoneType,
      dynamicUpdate,
      previewCount,
      configProcessor,
      cbNotify,
      isPreviewDial,
      isCallback,
      isCallbackDial,
      cbCnt,
      cbTab,
      teamList,
      team,
      callTeam,
      previewTeam
    } = this.props;
    let state = userState.State || '';
    let mainType = userState.mainType || '';
    let header = this.headerTitle(state, onCall, mainType);
    let _this = this;

    let numberMask = {};
    let phone_number = header.headerTitle
    try {
      teamList.map(e => {
        numberMask[e._id] = e.numberMasking || false;
      });
    } catch (error) {
    }
    // if(state==="preview"){
    //   phone_number = previewTeam && previewTeam.teamId && numberMask[`${previewTeam.teamId}`]===true?commonManager.maskText(phone_number):phone_number
    // }
    // else{
    phone_number = callTeam && callTeam.id && numberMask[`${callTeam.id}`] === true ? commonManager.maskText(phone_number) : phone_number
    // }
    let subState = header.subState;
    if (state === "preview") {
      subState = previewTeam && previewTeam.teamId && numberMask[`${previewTeam.teamId}`] === true ? commonManager.maskText(subState) : subState
    }
    // else if(state==="CONNECTED"){
    //   phone_number = callTeam && callTeam._id && numberMask[`${callTeam._id}`]===true?commonManager.maskText(phone_number):phone_number
    // }

    previewCount = previewCount || 0;

    return (
      <HeaderDialpad
        more={<img src='/images/widget-dots.svg' />}
        close={<img src='/images/widget-close.svg' />}
        onCloseClick={() => {
          dynamicUpdate({ key: 'isWidgetOpen', value: false });
        }}
        headerTitle={phone_number}
        background={header.background}
        Teamname={header.Teamname || ""}
        callerId={header.callerId || ""}
        isProfile={header.isProfile}
        isFullProfile={header.isFullProfile}
        profile={header.profile}
        // DO NOT REMOVE THIS COMMENT
        // renderInBound={header.renderInBound}
        subState={subState}
        isBack={callTab == "DTMF" || callTab == "ACW" || callTab == "TRANSFER_LIST" || callTab == "INFO" ? true : false}
        onBackBtn={() => {
          if (callTab == "TRANSFER_LIST") {
            _this.transferCancel()
          }
          dynamicUpdate({ key: 'callTab', value: "call" });
        }}
        sign={isConnected ? 'active' : ''}
        isConnected={isConnected}
        dropDownList={this.renderMenu()}
        previewBtnClick={() => {
          if (isPreviewDial) {
            let nextState = cbNotify ? "callback" : "online";
            let message = {
              type: 'stateHandler',
              state: nextState,
              subState: '',
              stateInfo: ''
            };
            this.sendMessage(message);
            dynamicUpdate({ key: 'isPreviewDial', value: false })
            configProcessor(`previewSkip`);
          } else {
            let message = {
              type: 'stateHandler',
              state: 'preview',
              subState: '',
              stateInfo: ''
            };
            this.sendMessage(message);
            changeTab("online")
          }
        }}
        showPreview={header.showPreview}
        previewBtn={isPreviewDial ? 'Back' : 'Preview'}
        previewCnt={previewCount}

        // callback
        cbBtnClick={() => {
          if (isCallbackDial) {
            this.sendMessage({
              type: 'stateHandler',
              state: "online",
              subState: '',
              stateInfo: ''
            });
            setTimeout(() => {
              dynamicUpdate({ key: 'cbTab', value: "" })
              dynamicUpdate({ key: 'cbListLoading', value: false })
              dynamicUpdate({ key: 'isCallbackDial', value: false })
            }, 100);
          } else {
            this.sendMessage({
              type: 'stateHandler',
              state: 'callback',
              subState: '',
              stateInfo: ''
            });
            changeTab("online")
            dynamicUpdate({ key: 'cbTab', value: "list" })
            dynamicUpdate({ key: 'cbListLoading', value: true })
            dynamicUpdate({ key: 'isCallbackDial', value: true })
            configProcessor(`notification:list`, {
              "page_no": 1,
              "limit": 100,
              "type": "callBack",
              "orderBy": "create_at",
              "order": "DESC",
            });
          }
        }}
        showCB={header.showCB}
        cbCnt={cbCnt || 0}
        cbBtn={isCallbackDial ? 'Back' : 'CallBack'}
      ></HeaderDialpad>
    );
  }
}

Header.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  isConnected: globalStateSelector.getIsConnected(state),
  callTab: globalStateSelector.getDynamic(state, { key: 'callTab' }),
  callInfo: globalStateSelector.getInfo(state),
  userState: globalStateSelector.getState(state),
  phoneType: globalStateSelector.getDynamic(state, { key: 'phoneType' }),
  onCall: globalStateSelector.getOnCall(state),
  customerNumber: globalStateSelector.getCallCustomerNumber(state),
  customerName: globalStateSelector.getCallCustomerName(state),
  callTeam: globalStateSelector.getDynamic(state, { key: 'callTeam' }),
  callerId: globalStateSelector.getDynamic(state, { key: 'callerId' }),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  previewCount: globalStateSelector.getDynamic(state, { key: 'previewCount' }),
  isPreviewDial: globalStateSelector.getDynamic(state, { key: 'isPreviewDial' }),
  isCallbackDial: globalStateSelector.getDynamic(state, { key: 'isCallbackDial' }),
  previewTeam: globalStateSelector.getDynamic(state, { key: 'previewTeam' }),
  selectedTab: globalStateSelector.getSelectedTab(state),
  microPhoneState: globalStateSelector.getDynamic(state, { key: 'microPhoneState' }),
  cbTab: globalStateSelector.getDynamic(state, { key: 'cbTab' }),
  cbNotify: globalStateSelector.getDynamic(state, { key: 'cbNotify' }),
  timerText: globalStateSelector.getDynamic(state, { key: 'timerText' }),
  sipConfig: globalStateSelector.getDynamic(state, { key: 'sipConfig' }),
  cbCnt: globalStateSelector.getDynamic(state, { key: 'cbCnt' }),
  isCallback: globalStateSelector.getDynamic(state, { key: 'isCallback' }),
  teamList: globalStateSelector.getTeamList(state),
  team: globalStateSelector.getSelectedTeam(state),

});

const dispatchToProps = dispatch => ({
  clearSocketConnection: () => {
    // dispatch(messageAction.emitSocketMessage());
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  callState: state => {
    dispatch(globalAction.callState({ data: state }));
  },
  changeTab: tName => {
    dispatch(globalAction.tabState({ data: tName }));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  registerUser: (type, messageData) => {
    dispatch(messageAction.registerUser(type, messageData));
  },
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  }
});

export default connect(stateToProps, dispatchToProps)(Header);



// WEBPACK FOOTER //
// src/dialpad/components/layout/Header.js